<div [class.rtl]="!isEnglish" [class.ltr]="isEnglish" fxFlex>
  <mat-sidenav-container
    hasBackdrop="false"
    class="menu-state {{ menuSizeState }}"
    [class.overlay-sidenav]="isMenuSizeStateClicked"
  >
    <mat-sidenav
      #sidenav
      opened="true"
      disableClose="true"
      [mode]="mode"
      class="main-menu menu-style {{ menuSizeState }}"
      ngClass.gt-sm="has-border"
    >
      <nav>
        <mat-list>
          @if (menuSizeState === 'large') {
          <div class="menu-brand" fxLayout="row">
            @if(isMenuSizeStateClicked){
            <a class="menu-button menu-button-clicked" href="javascript:void(0);" (click)="toggleMenuSize()">
              <mat-icon>menu</mat-icon>
            </a>
            }
            <div>
              <img src="/assets/images/makkah-logo-x.png" width="250px" alt="Afaqy" />
            </div>
          </div>

          } @if (menuSizeState === 'small' ) {
          <a class="menu-button" href="javascript:void(0);" (click)="toggleMenuSize()">
            <mat-icon>menu</mat-icon>
          </a>
          } @if (menuSizeState === 'large') {
          <div class="position-relative scrollable-container" [perfectScrollbar]>
            <mat-divider></mat-divider>
            @for (item of menuItems.items; track item; let i = $index) { @if (checkPermission(item.permissionsKey)) {
            @if (!item?.children?.length) {
            <a mat-list-item [routerLink]="item.url" routerLinkActive="active" (click)="onNavigate()">
              <span>{{ 'menu.' + item.title | translate }}</span>
            </a>
            } @if (item?.children?.length > 0) {
            <mat-accordion multi="true" displayMode="flat">
              <mat-expansion-panel
                class="mat-elevation-z0"
                [expanded]="checkCurrentRoute(item) || checkChildParentRoute(item) || item.active"
              >
                <mat-expansion-panel-header
                  (click)="toggle(i)"
                  [class.active]="checkCurrentRoute(item) || checkChildParentRoute(item)"
                  fxLayout="row"
                >
                  <span>{{ 'menu.' + item.title | translate }}</span>
                  <mat-icon [svgIcon]="item.active ? 'sort-up' : 'sort-down'" class="main-color"></mat-icon>
                </mat-expansion-panel-header>
                @for (child of item.children; track child; let i = $index) {
                <mat-list>
                  @if (!child.hidden) {
                  <a
                    class="menu-item"
                    mat-list-item
                    [routerLink]="child.url"
                    [class.active]="router.url.includes(child.url.split('-')[0])"
                    (click)="onNavigate()"
                  >
                    <span>{{ 'menu.' + child.title | translate }}</span>
                  </a>
                  }
                </mat-list>
                }
              </mat-expansion-panel>
            </mat-accordion>
            }
            <mat-divider></mat-divider>
            } }
          </div>
          }
        </mat-list>
      </nav>
    </mat-sidenav>
    <app-header
      [sidenav]="sidenav"
      [menuSizeState]="menuSizeState"
      (menuSizeStateEvent)="toggleMenuSize()"
      class="menu-state {{ menuSizeState }}"
    ></app-header>
    <div [class.overlay-bg]="isMenuSizeStateClicked" (click)="onOverlay()">
      <div
        class="main-container menu-{{ menuSizeState }}"
        [perfectScrollbar]
        [class.pointer-events-none]="isMenuSizeStateClicked"
      >
        <div class="main-container-inner ps" [perfectScrollbar]>
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </mat-sidenav-container>
</div>
